import { actions } from "./actions";
import { mutations } from "./mutations";
const state = {
    data: {},
    fieldInfoList: [],
    fieldTable: {},
    tabnow: 'rule'
};

export default {
    state,
    actions,
    mutations
};